<template>
    <div>
      <div class="a-tab__title-block admin__a-tab">
        <h3>{{$t('form.lot.lot-status')}}</h3>
      </div>
      <div class="a-container-form admin-buy__block">
        <div class="a-label ">{{$t('form.lot.status')}}:</div>
        <p class="a-input a-input--disabled">{{$t(lot.state.label)}}</p>
      </div>
      <div class="a-container-form admin-buy__block" v-if="lot.state == enums.LotState.DECLINED">
        <div class="a-label ">{{$t('labels.reason-for-rejection')}}:</div>
        <p class="a-input a-input--disabled">{{lot.reason}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-container-form--align-start" v-if="lot.modifiedTime">
        <div class="a-label">{{$t('labels.last-modified-date')}}:</div>
        <date-time class="a-input a-input--disabled" :value="lot.modifiedTime" :time="false"></date-time>
      </div>

      <div class="a-tab__title-block admin__a-tab">
        <h3>{{$t('form.lot.general-information')}}</h3>
      </div>

      <div class="a-container-form admin-buy__block a-container-form--align-start">
        <div class="a-label">{{$t('form.lot.creation-date')}}:</div>
        <date-time class="a-input a-input--disabled" :value="lot.creationTime"></date-time>
      </div>
      <div class="a-container-form admin-buy__block a-container-form--align-start">
        <div class="a-label">{{$t('form.lot.originator')}}:</div>
        <p class="a-input a-input--disabled">{{lot.owner | fullName}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-container-form--align-start">
        <div class="a-label">{{$t('form.lot.originator-department')}}:</div>
        <p class="a-input a-input--disabled" v-if="lot.owner.department">{{lot.owner.department}}</p>
        <p class="a-input a-input--disabled" v-else>{{$t('labels.department-not-specified')}}</p>
      </div>
      <div class="a-container-form admin-buy__block">
        <div class="a-label">{{$t('labels.tender-number')}}:</div>
        <p class="a-input a-input--disabled">{{lot.tenderId | defaultValue($t('labels.tender-number-not-filled'))}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-mandatory">
        <div class="a-label ">{{$t('labels.customer-lot-number')}}:</div>
        <lot-number-search v-model="lot.catalog"
                           @input="checkForm(lot)"
                           v-if="canEditFull">
        </lot-number-search>
        <p class="a-input a-input--disabled" v-else>{{lot.catalog.name | defaultValue($t('labels.lot-number-not-specified'))}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-container-form--align-start">
        <div class="a-label">{{$t('form.lot.actual-tender-method')}}:</div>
        <p class="a-input a-input--disabled">{{$t(lot.methods.actual.label)}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-mandatory">
        <div class="a-label ">{{$t('form.lot.planned-tender-method')}}:</div>
        <dropdown-new class="select-w-260" v-model="lot.methods.planned" v-if="canEditFull" @change="checkForm(lot)">
          <option value :label="'tender-method.empty'"></option>
          <option :value="enums.TenderMethod.TENDER" :label="'tender-method.tender'"></option>
          <option :value="enums.TenderMethod.REQUEST_FOR_PRICE" :label="'tender-method.request-for-price'"></option>
          <option :value="enums.TenderMethod.REQUEST_FOR_PROPOSALS" :label="'tender-method.request-for-proposals'"></option>
          <option :value="enums.TenderMethod.ONE" :label="'tender-method.one'"></option>
          <option :value="enums.TenderMethod.REDUCTION" :label="'tender-method.reduction'"></option>
        </dropdown-new>
        <p class="a-input a-input--disabled" v-else>{{$t(lot.methods.planned.label)}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-container-form--align-start a-mandatory">
        <div class="a-label">{{$t('form.lot.tender-subject')}}:</div>
        <div class="a-flex-start a-width-100-percent">
          <textarea class="a-textarea"
                    rows="2"
                    :placeholder="$t('form.lot.tender-subject')"
                    v-if="canEditFull"
                    v-model.lazy="lot.name"
                    @blur="checkForm(lot)"></textarea>
          <p class="a-input a-input--disabled" v-else>{{lot.name | defaultValue($t('form.lot.tender-subject-not-specified'))}}</p>
        </div>
      </div>
      <div class="a-container-form admin-buy__block a-mandatory">
        <div class="a-label ">{{$t('form.lot.tender-initiator')}}:</div>
        <department-search class="a-width-100-percent"
                           v-model="lot.department"
                           @input="checkForm(lot)"
                           v-if="canEditFull">
        </department-search>
        <p class="a-input a-input--disabled" v-else>{{lot.department ? lot.department.name : 'Не указан'}}</p>
      </div>
      <div class="a-container-form admin-buy__block">
        <div class="a-label">{{$t('form.lot.lot-initial-price')}}:</div>
        <div class="a-checkbox admin-buy__input-and-checkbox">
          <input-cost class="a-input admin-buy__input-medium" v-model="lot.price" v-if="canEditFull && !isSpecFull" @blur="checkForm(lot)"></input-cost>
          <p class="a-input a-input--disabled admin-buy__input-medium" v-else>{{lot.price | price}}</p>
          <div class="a-width-100-percent a-checkbox" style="text-align: center" v-if="canEditFull">
            <label class="a-checkbox__label">
              <input class="a-checkbox__input" type="checkbox" :disabled="!canEditFull" v-model="lot.withTaxes" @change="checkForm(lot)">
              <span class="a-checkbox__icon"></span>
              <span class="a-checkbox__text">{{$t('form.lot.including-taxes')}}</span>
            </label>
          </div>
          <span style="margin-left: 8px;" v-else>
            <p class="a-input a-input--disabled" v-if="lot.withTaxes">({{$t('form.lot.with-taxes')}})</p>
            <p class="a-input a-input--disabled" v-else>({{$t('form.lot.without-taxes')}})</p>
          </span>
        </div>
      </div>
      <div class="a-container-form admin-buy__block" v-if="isSpecFull">
        <div class="a-label">{{$t('form.lot.dumping-threshold')}}:</div>
        <template v-if="canEditFull">
          <input-percent class="a-input a-input--w-100"
                      v-model="lot.threshold.value"
                      @blur="checkForm(lot)"
                      v-if="lot.threshold.isPercent">
          </input-percent>

          <input-cost class="a-input a-input--w-100"
                         v-model="lot.threshold.value"
                         @blur="checkForm(lot)"
                         v-else>
          </input-cost>
        </template>
        <template v-else>
          <p class="a-input a-input--disabled" v-if="lot.threshold.isPercent">{{lot.threshold.value | percent}}</p>
          <p class="a-input a-input--disabled" v-else>{{lot.threshold.value | price}}</p>
        </template>

        <dropdown-new class="select-w-95" v-model="lot.threshold.unit" @change="checkForm(lot)" v-if="canEditFull">
          <option value="percent">%</option>
          <option value="money">Значение</option>
        </dropdown-new>
        <p class="a-input a-input--disabled" v-else-if="lot.threshold.unit === 'percent'">%</p>
      </div>
      <div class="a-container-form admin-buy__block">
        <div class="a-label ">{{$t('form.lot.lot-currency')}}</div>
        <dropdown-new class="admin-buy__select"
                      :options="enums.Currency.options.all"
                      v-model="lot.currency"
                      v-if="canEditFull" @change="checkForm(lot)">
        </dropdown-new>
        <p class="a-input a-input--disabled" v-else>{{$t(lot.currency.label)}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-mandatory">
        <div class="a-label ">{{$t('form.lot.other-description')}}:</div>
        <textarea class="a-textarea" rows="2" :placeholder="$t('form.lot.description')" v-if="canEditFull" v-model="lot.description" @blur="checkForm(lot)"></textarea>
        <p class="a-input a-input--disabled" v-else>{{lot.description | defaultValue($t('form.lot.description-not-specified'))}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-container-form--align-start a-mandatory" v-if="lot.methods.planned != enums.TenderMethod.ONE">
        <div class="a-label">{{$t('form.lot.invitees-from-category')}}:</div>
        <tags-new class="a-textarea"
                  :validator="email"
                  :mutator="mutators.email"
                  :placeholder="$t('labels.email-list')"
                  v-model="lot.participants.auto"
                  :disabled="!canEditFull && !canEditPartially"
                  @change="checkForm(lot)"></tags-new>
<!--        <p class="a-input a-input&#45;&#45;disabled" v-else>{{lot.participants.auto | fullList}}</p>-->
      </div>
      <div class="a-container-form admin-buy__block a-container-form--align-start">
        <div class="a-label">{{$t('form.lot.other-invitees')}}:</div>
        <tags-new class="a-textarea"
                  :validator="email"
                  :mutator="mutators.email"
                  :placeholder="$t('labels.email-list')"
                  v-model="lot.participants.manual"
                  :disabled="!canEditFull && !canEditPartially"
                  @change="checkForm(lot)"></tags-new>
<!--        <p class="a-input a-input&#45;&#45;disabled" v-else>{{lot.participants.manual | fullList}}</p>-->
      </div>
      <div class="a-container-form admin-buy__block a-mandatory">
        <div class="a-label ">{{$t('form.lot.tender-categories')}}</div>
        <categories-search class="a-width-100-percent"
                           :placeholder="$t('form.lot.tender-categories')"
                           multiple
                           v-model="lot.categories"
                           @input="checkForm(lot)"
                           v-if="canEditFull || canEditPartially">
          </categories-search>
        <p class="a-input a-input--disabled" v-else>{{lot.categories.map(e => e.name) | fullList}}</p>
      </div>
      <div class="a-container-form admin-buy__block a-mandatory">
        <div class="a-label ">{{$t('form.lot.participation-mode')}}:</div>
        <dropdown-new class="admin-buy__select" v-model="lot.participationMode" v-if="canEditFull" @change="checkForm(lot)">
          <option :value="enums.TenderParticipationMode.OPEN" :label="'tender-participation-mode.open'"></option>
          <option :value="enums.TenderParticipationMode.CLOSED" :label="'tender-participation-mode.closed'"></option>
        </dropdown-new>
        <p class="a-input a-input--disabled" v-else>{{$t(lot.participationMode.label)}}</p>
      </div>
      <div class="admin-buy__block-footer a-mandatory">
        <div class="a-input-file-block">
          <p class="a-label a-label--w-260">1. {{$t('form.lot.lot-documentation')}}</p>
          <br>
          <file-link :name="doc.name"
                     :link="externalLink(doc.uid)"
                     :size="doc.size"
                     :removable="canEditFull || canEditPartially"
                     :key="doc.uid"
                     :signed="doc.hasSign"
                     @remove="onFileRemoveClick({ docId: doc.id, isDocument: true })"
                     @onsigncheck="onFileSignCheckClick(doc.id)"
                     v-for="doc in lot.documents.docs">
          </file-link>

          <file-picker :mode="lot.documents.docs.length === 0 ? 'link': 'button'"
                       @prepared="onFileReady($event, { isDocument: true })"
                       v-if="canEditFull || canEditPartially">
          </file-picker>
        </div>
      </div>
      <div class="admin-buy__block-footer">
        <p class="a-input a-input--disabled ">2. {{$t('form.lot.specification')}}</p>
        <br>
        <router-link class="gui-btn gui-btn--red gui-btn--w-400"
                     :to="{name: 'purchases-lot-details', params: { lotId: lot.id, tab: 'specifications'}}">
          {{$t('buttons.create-lot-specification')}}
        </router-link>
      </div>
      <div class="admin-buy__block-footer">
        <div class="a-input-file-block ">
          <p class="a-input a-input--disabled ">3. {{$t('form.lot.detailed-tender-subject')}}</p>
          <br>
          <file-link :name="doc.name"
                     :size="doc.size"
                     :link="externalLink(doc.uid)"
                     :removable="canEditFull || canEditPartially"
                     :key="doc.uid"
                     :signed="doc.hasSign"
                     @remove="onFileRemoveClick({ docId: doc.id, isDetails: true })"
                     @onsigncheck="onFileSignCheckClick(doc.id)"
                     v-for="doc in lot.documents.details">
          </file-link>

          <file-picker :mode="lot.documents.details.length === 0 ? 'link' : 'button'"
                       @prepared="onFileReady($event, { isDetails: true })"
                       v-if="canEditFull || canEditPartially">
          </file-picker>
        </div>
      </div>
      <div class="a-container-form admin-buy__block" v-if="lot.permissions.CAN_DECLINE_LOT || lot.permissions.CAN_DECLINE_APPROVED_LOT">
        <div class="a-label ">{{$t('form.lot.reason-for-rejection')}}</div>
        <div class="a-form-field a-width-100-percent">
          <textarea class="a-textarea" rows="2" v-model="lot.reason"></textarea>
          <span class="a-validation-error" v-if="$v.lot.reason.$dirty && !$v.lot.reason.required">{{$t('validation-error.specify-reason')}}</span>
        </div>
      </div>
      <div class="a-container-form admin-buy__block" v-if="lot.permissions.CAN_CANCEL_LOT">
        <div class="a-label ">{{$t('form.lot.reason-for-cancelling')}}</div>
        <div class="a-form-field a-width-100-percent">
          <textarea class="a-textarea" rows="2" v-model="lot.cancelReason"></textarea>
          <span class="a-validation-error" v-if="$v.lot.cancelReason.$dirty && !$v.lot.cancelReason.required">{{$t('validation-error.specify-reason')}}</span>
        </div>
      </div>
      <div class="a-container-form admin-buy__block a-mandatory" v-if="lot.permissions.CAN_ACCEPT_CANCELLING_LOT || lot.permissions.CAN_REJECT_CANCELLING_LOT">
        <div class="a-label ">{{$t('form.lot.reason-for-cancelling')}}:</div>
        <p class="a-input a-input--disabled">{{lot.cancelReason}}</p>
      </div>

      <div class="a-container-form admin-buy__block a-mandatory" v-if="isChangeDescriptionRequired">
        <div class="a-label ">{{$t('form.lot.changes-description')}}</div>
        <div class="a-form-field a-width-100-percent">
          <textarea class="a-textarea"
                    rows="2"
                    v-model="lot.changeDescription"
                    @change="checkForm(lot)">
          </textarea>
          <span class="a-validation-error" v-if="$v.lot.changeDescription.$dirty && !$v.lot.changeDescription.required">{{$t('validation-error.specify-changes-description')}}</span>
        </div>
      </div>
      <div class="a-container-form admin-buy__block" v-else-if="lot.changeDescription">
        <div class="a-label ">{{$t('form.lot.changes-description')}}:</div>
        <span class="a-input a-input--disabled u-red-color">{{lot.changeDescription}}</span>
      </div>

      <div class="admin-buy__block-footer" style="padding: 0"></div>
      <div class="admin-buy__block-gui-btn a-flex-start">
        <button class="gui-btn gui-btn--red gui-btn--w-167" type="button" v-if="lot.permissions.CAN_COPY_LOT" @click="copyLot">{{$t('buttons.copy-lot')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-207" type="button" v-if="lot.isFilled && lot.permissions.CAN_PUBLISH_LOT" @click="onSignLotClick">{{$t('buttons.publish-lot')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-184" type="button" v-if="lot.permissions.CAN_APPROVE_LOT" @click="approveLot">{{$t('buttons.approve-lot')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-184" type="button" v-if="lot.permissions.CAN_DECLINE_LOT" @click="declineLot">{{$t('buttons.reject-lot')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-184" type="button" v-if="lot.permissions.CAN_CANCEL_LOT" @click="cancelLot">{{$t('buttons.cancel-lot')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-207" type="button" v-if="lot.permissions.CAN_DECLINE_APPROVED_LOT" @click="declineApprovedLot">{{$t('buttons.cancel-lot-approval')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-207" type="button" :disabled="saveButtonDisabled" v-if="lot.permissions.CAN_MANUALLY_SAVE_LOT" @click="saveChanges">{{$t('buttons.save-changes-in-lot')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-207" type="button" v-if="lot.permissions.CAN_ADD_LOT_IN_FAVORITES">{{$t('buttons.save-lot-to-favorites')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-207" type="button" v-if="lot.permissions.CAN_REMOVE_LOT_FROM_FAVORITES">{{$t('buttons.remove-lot-from-favorites')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-207" type="button" v-if="lot.permissions.CAN_DELETE_LOT" @click="removeLot">{{$t('buttons.delete-lot')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="lot.isFilled && lot.permissions.CAN_SEND_LOT_FOR_APPROVE" @click="onSignLotClick">{{$t('buttons.send-lot-for-approval')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="lot.permissions.CAN_CREATE_TENDER" @click="createTender">{{$t('buttons.create-tender')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="lot.permissions.CAN_ACCEPT_CANCELLING_LOT" @click="acceptCancellingLot">{{$t('buttons.approve-lot-cancellation')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-278" type="button" v-if="lot.permissions.CAN_REJECT_CANCELLING_LOT" @click="rejectCancellingLot">{{$t('buttons.reject-lot-cancellation')}}</button>
      </div>
      <signing-dialog ref="signLot"
                      @signed="publishLot">
      </signing-dialog>

      <signature-details-dialog ref="signCheck"></signature-details-dialog>
      <loading v-if="loading"></loading>
    </div>
</template>

<script>
  import { requiredIf, email } from '@/validators'

  import LotState from '@/api/types/lot-state'
  import TenderMethod from '@/api/types/tender-method'
  import Currency from '@/api/types/currency'
  import TenderParticipationMode from '@/api/types/tender-participation-mode'

  import Tags from '@/widgets/tags'
  import TagsNew from '@/widgets/tags-new'
  import SigningDialog from '@/components/common/dialogs/SigningDialog'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import CategoriesSearch from '@/components/common/inputs/CategoriesSearch'
  import DepartmentSearch from '@/components/common/inputs/DepartmentSearch'
  import LotNumberSearch from '@/components/common/inputs/LotNumberSearch'

  import CommonMixins from './mixins/common'
  import PermissionsMixins from './mixins/permissions'

  export default {
    props: {
      lot: Object
    },

    components: {
      Tags,
      TagsNew,
      SigningDialog,
      SignatureDetailsDialog,
      CategoriesSearch,
      DepartmentSearch,
      LotNumberSearch
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    data: () => ({
      isReasonRequired: false,
      isCancelReasonRequired: false,

      mutators: {
        email: items => {
          const result = [];

          items = items || [];
          for(let i = 0; i < items.length; ++i) {
            const item = items[i];

            if (item.organization) {
              let org = _.find(result, { group: item.organization});

              if (!org) {
                result.push({
                  removable: false,
                  group: item.organization,
                  value: item.organization,
                  items: []
                });
                org = _.last(result);
              }

              org.items.push({
                idx: i,
                value: item.email,
                removable: true
              });
            }
            else {
              result.push({
                idx: i,
                value: _.get(item, 'email', item),
                removable: true,
              });
            }
          }

          return result;
        }
      }
    }),

    validations: {
      lot: {
        reason: {
          required: requiredIf(function () {
            return this.isReasonRequired
          })
        },

        cancelReason: {
          required: requiredIf(function () {
            return this.isCancelReasonRequired
          })
        },

        changeDescription: {
          required: requiredIf(function () {
            return this.isChangeDescriptionRequired
          })
        }
      }
    },

    computed: {
      isChangeDescriptionRequired() {
        return (this.canEditFull || this.canEditPartially) && this.lot.permissions.CAN_EDIT_CHANGES_IN_LOT_DESCRIPTION;
      },

      isSpecFull() {
        if (this.lot.currency.valueOf() === Currency.EMPTY) {
          return false;
        }

        let isFull = true;

        const total = this.lot.specs.reduce((acc, spec) => {
          if (!spec.price) {
            isFull = false;
          }
          acc += (spec.price * spec.count) || 0;
          return acc;
        }, 0);

        isFull = isFull && total;

        return isFull;
      }
    },

    methods: {
      email,

      async onSignLotClick() {
        this.runAction(async () => {
          try {
            const text = await this.$store.dispatch('getLotSigningText', this.lot);
            this.$refs.signLot.open({ text });
          }
          catch(e) {
            console.error('Unable to fetch signing text for tender', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onFileRemoveClick({docId, isDocument, isSpecification}) {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('removeDocumentFromLot', {
              lotId: this.lot.id,
              docId,
              isDocument,
              isSpecification});
          }
          catch(e) {
            console.error('Unable to remove file from lot', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onFileReady(file, options) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addDocumentToLot', {
              lotId: this.lot.id,
              file: file.file,
              sign: file.sign,
              isDocument: options.isDocument,
              isSpecification: options.isSpecification
            });
          }
          catch(e) {
            console.error('unable to attach file to lot', e);

            this.globalErrorHandler(e, {
              'BAD_SIGNATURE': 'errors.lot.attaching-file.bad-signature',
              'UNKNOWN_SIGNATURE': 'errors.lot.attaching-file.unknown-signature'
            }, 'errors.lot.attaching-file.unknown');
          }
        })
      },

      async publishLot(result) {
        this.runAction(async () => {
          try {
            this.$refs.signLot.close();

            await this.$store.dispatch('publishLot', {
              id: this.lot.id,
              text: result.data,
              signature: result.signature
            });
          }
          catch(e) {
            console.error('Unable to publish lot', e);

            this.globalErrorHandler(e, {
              'ALREADY_EXISTS': 'errors.lot.publishing-lot.already-exists'
            });
          }
        })
      },

      async copyLot() {
        this.runAction(async () => {
          try {
            const lotId = await this.$store.dispatch('copyLot', this.lot);
            this.$router.push({ name: 'purchases-lot-details', params: { lotId, tab: 'overview' } });
          }
          catch(e) {
            console.error('Unable to copy lot', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async removeLot() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('removeLot', this.lot);
            this.$router.push({ name: 'purchases-lots'});
          }
          catch(e) {
            console.error('unable to remove lot', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async createTender() {
        this.runAction(async () => {
          try {
            const tenderId = await this.$store.dispatch('createTenderForLot', this.lot);
            this.$router.push({ name: 'purchases-tender-details', params: { tenderId, tab: 'overview' } });
          }
          catch(e) {
            console.error('unable to create a tender for lot', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async approveLot() {
        this.isReasonRequired = false;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            await this.$store.dispatch('acceptLot', this.lot);
          }
          catch(e) {
            console.error('unable to approve lot', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async declineLot() {
        this.isReasonRequired = true;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            await this.$store.dispatch('declineLot', this.lot);
          }
          catch(e) {
            console.error('unable to decline lot', e);
            this.globalErrorHandler(e);
          }
          this.isReasonRequired = false;
        });
      },

      async cancelLot() {
        this.isCancelReasonRequired = true;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            await this.$store.dispatch('cancelLot', this.lot);
          }
          catch(e) {
            console.error('unable to cancel lot', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async declineApprovedLot() {
        this.isReasonRequired = true;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            await this.$store.dispatch('declineApprovedLot', this.lot);
          }
          catch(e) {
            console.error('unable to reject lot approval', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onFileSignCheckClick(fileId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkLotFileSignature', {
              lotId: this.lot.id,
              fileId: fileId
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('unable to check file signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async rejectCancellingLot() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('rejectCancellingLot', this.lot);
          }
          catch(e) {
            console.error('unable to reject lot cancellation', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async acceptCancellingLot() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('acceptCancellingLot', this.lot);
          }
          catch(e) {
            console.error('unable to approve lot cancellation', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gui-btn[disabled] {
    background: #E6E6E6;
    color: #808080;
  }

  .a-mandatory {
    h3::after,
    .a-label::before {
      content: '*';
      color: #cc061a;
    }
  }
</style>
